import { Dropdown, Button } from "antd";
import { TbTransactionDollar } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

export const LogNavigator = ({ options }: { options: { to: string; label: string }[] }) => {
  const items = options.map((opt) => ({
    key: opt.to,
    label: opt.label,
    onClick: () => window.open(opt.to, "_blank"),
  }));

  return (
    <Dropdown menu={{ items }}>
      <Button icon={<TbTransactionDollar />} variant="outlined" color="green">
        View Transaction Logs
      </Button>
    </Dropdown>
  );
};
